import VolcengineAnalytics from '@cndinfo/cube-analytics-sdk'
const volcengine = {
  bind(el, binding, vNode) {
    const dom = el
    const tagName = dom.tagName.toLowerCase()
    let actionType = ''
    const vNodeItem = vNode.componentInstance.$options
    const propsData = vNodeItem.propsData
    const router = vNode.componentInstance.$router
    // 初始化
    const params = {
      routerObject: router // 完整 vue-router 对象
    }
    const analyticsInstance = new VolcengineAnalytics(params)
    analyticsInstance.start()
    switch (tagName) {
      case 'button':
        actionType = 'button'
        break
      case 'div':
        if (tagName === 'div' && propsData.gridOptions) {
          actionType = 'AgGridVue'
        }
        break
    }
    switch (actionType) {
      // button 和 el-button的火山引擎采集事件
      case 'button':
        el.onclick = function() {
          try {
            analyticsInstance.reportEvent('button_click', {
              button_name: el.innerText
            })
          } catch (e) {
            console.log(e)
          }
        }
        break
      // agGrid 埋点
      case 'AgGridVue':
        var gridOptions = propsData.gridOptions
        var columnsWidthObject = {}
        var columnsMovingObject = {}
        var vNodeData = vNode.componentInstance.$vnode.data
        var tableName = vNodeData.ref ? vNodeData.ref : ''
        var movingColumnName
        var widthChangeName
        var movingColId
        var widthChangeId
        gridOptions.onGridReady = function(params) {
          console.log('onGridReady')
          const columns = params.columnApi.getAllColumns()
          columns.forEach((item) => {
            item.addEventListener('sortChanged', (event) => {
              const columnName = event.column.colDef.headerName
              console.log('aggrid_column_sort_changed')
              try {
                analyticsInstance.reportEvent('aggrid_column_sort_changed', {
                  aggrid_name: tableName,
                  aggrid_column_name: columnName
                })
              } catch (e) {
                console.log(e)
              }
            })
            item.addEventListener('movingChanged', (event) => {
              movingColId = event.column.colId
            })
            item.addEventListener('widthChanged', (event) => {
              console.log('aggrid_column_width_changed')
              // 宽度改变的时候触发
              widthChangeId = event.column.colId
            })
          })
        }
        // 拖拽结束之前触发 但是 widthChanged 也会触发
        gridOptions.onDragStarted = function(params) {
          const oldColumns = params.columnApi.columnController.gridColumns
          oldColumns.forEach((item, index) => {
            columnsMovingObject[item.colId] = {
              index,
              name: item.colDef.headerName
            }
            columnsWidthObject[item.colId] = {
              width: item.actualWidth,
              name: item.colDef.headerName
            }
          })
        }
        // 拖拽结束之后触发 但是 widthChanged 也会触发
        gridOptions.onDragStopped = function(params) {
          const nowColumns = params.columnApi.columnController.gridColumns
          let beforeIndex = 0
          let afterIndex = 0
          let oldWith = 0
          nowColumns.forEach((item, index) => {
            if (item.colId === movingColId) {
              movingColumnName = columnsMovingObject[item.colId].name
              beforeIndex = columnsMovingObject[item.colId].index
              afterIndex = index
            }
            if (item.colId === widthChangeId) {
              oldWith = columnsWidthObject[widthChangeId].width
              widthChangeName = columnsWidthObject[widthChangeId].name
              columnsWidthObject[widthChangeId].width = item.actualWidth
            }
          })
          if (beforeIndex === afterIndex) {
            const isWidthNotChanged =
              oldWith === columnsWidthObject[widthChangeId].width
            const isNotDragSort = gridOptions.suppressMovableColumns
            if (isNotDragSort && isWidthNotChanged) {
              // 表明设置了禁止拖拽排序
              return
            }
            // 表明是 widthChanged 触发的
            try {
              analyticsInstance.reportEvent('aggrid_column_width_changed', {
                aggrid_name: tableName,
                aggrid_column_name: widthChangeName,
                aggrid_column_width_before: oldWith,
                aggrid_column_width_after:
                  columnsWidthObject[widthChangeId].width
              })
            } catch (e) {
              console.log('')
            }
          } else {
            // 拖动排序触发的
            try {
              analyticsInstance.reportEvent('aggrid_column_moving_changed', {
                aggrid_name: tableName,
                aggrid_column_name: movingColumnName,
                aggrid_column_sort_index_before: beforeIndex,
                aggrid_column_sort_index_after: afterIndex
              })
            } catch (e) {
              console.log(e)
            }
          }
        }
        break
    }
  }
}
export default volcengine
